import type { LevelDefinition } from "../levels/types";

interface MapBrowserProps {
  maps: LevelDefinition[];
  selectedMapId: string;
  onSelect: (mapId: string) => void;
  onBack?: () => void;
  onStart?: () => void;
  startLabel?: string;
}

const actionClass = "font-mono text-[11px] uppercase tracking-[0.32em] text-white/60 transition-colors duration-200 hover:text-[#ffb347] focus-visible:outline-none focus-visible:text-[#ffb347]";

export function MapBrowser({ maps, selectedMapId, onSelect, onBack, onStart, startLabel = "Start" }: MapBrowserProps) {
  return (
    <div className="space-y-8">
      <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
        {maps.map((map) => {
          const selected = map.id === selectedMapId;

          return (
            <button
              key={map.id}
              type="button"
              onClick={() => onSelect(map.id)}
              className={`group flex flex-col gap-4 text-left transition-opacity duration-200 focus-visible:outline-none ${selected ? "opacity-100" : "opacity-85 hover:opacity-100"}`}
            >
              <div className="overflow-hidden border-b border-white/10 pb-4">
                <img src={map.thumbnail} alt={map.name} className={`aspect-[16/9] w-full object-cover transition-transform duration-300 ${selected ? "scale-[1.01]" : "group-hover:scale-[1.02]"}`} />
              </div>
              <div className="space-y-2">
                <div className="flex items-baseline justify-between gap-3">
                  <span className={`font-mono text-sm uppercase tracking-[0.32em] ${selected ? "text-[#ffb347]" : "text-white/88 group-hover:text-[#ffb347]"}`}>{map.name}</span>
                  <span className={`font-mono text-[10px] uppercase tracking-[0.28em] ${selected ? "text-[#ffb347]/80" : "text-white/35"}`}>{selected ? "Selected" : map.id}</span>
                </div>
                <p className="text-sm leading-6 text-white/62">{map.description}</p>
                <div className="flex flex-wrap gap-3 pt-1 font-mono text-[10px] uppercase tracking-[0.28em] text-white/40">
                  {map.supportedModes.map((mode) => (
                    <span key={mode}>{mode}</span>
                  ))}
                </div>
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex items-center justify-between gap-4 border-t border-white/10 pt-5">
        {onBack ? (
          <button type="button" className={actionClass} onClick={onBack}>
            Back
          </button>
        ) : <div />}
        {onStart ? (
          <button type="button" className="font-mono text-[11px] uppercase tracking-[0.34em] text-[#ffb347] transition-opacity duration-200 hover:opacity-80 focus-visible:outline-none" onClick={onStart}>
            {startLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
